import { TargetProps } from './interfaces';
import { TargetContainer } from './styles';

export default function Target({ completed, discount }: TargetProps) {
	return <TargetContainer completed={completed} discount={discount} />;
}
